import { useState, PropsWithChildren } from 'react';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Markdown from '../../ManagementPanel/components/Markdown';
import { styled } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

export const PolicyStreamFaq = () => {
  return (
    <FaqContainer>
      <Typography variant='h3'>Frequently Asked Questions</Typography>
      {faqData.map(({ question, answer }) => {
        return (
          <FaqAccordion question={question} answer={answer} />
          // <FaqQuestionAnswerContainer>
          //   <FaqQuestion expandIcon={<ExpandMoreIcon />}>
          //     {question}
          //   </FaqQuestion>
          //   <FaqAnswer>{answer}</FaqAnswer>
          // </FaqQuestionAnswerContainer>
        );
      })}
    </FaqContainer>
  );
};

interface FaqAccordionProps {
  question: string;
  answer: string;
}
const FaqAccordion = ({ question, answer }: FaqAccordionProps) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <FaqQuestionAnswerContainer
      expanded={expanded}
      onChange={(_e, isExpanded) => {
        setExpanded(isExpanded);
      }}
    >
      <FaqQuestion expandIcon={<FaqExpandIcon selected={expanded} />}>
        {question}
      </FaqQuestion>
      <FaqAnswer>{answer}</FaqAnswer>
    </FaqQuestionAnswerContainer>
  );
};

interface FaqExpandIconProps {
  selected: boolean;
}
const FaqExpandIcon = ({ selected }: FaqExpandIconProps) => {
  return selected ? <RemoveIcon /> : <AddIcon />;
};

const FaqQuestionAnswerContainer = styled(Accordion)(({ theme }) => {
  return {
    borderRadius: theme.shape.borderRadius,
    '&:before': { display: 'none' },
  };
});

const FaqQuestion = styled(AccordionSummary)({ fontWeight: 'bold' });
const StyledAccordionDetails = styled(AccordionDetails)({});
const FaqContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginTop: theme.spacing(4),
  };
});

interface FaqAnswerProps extends PropsWithChildren<{}> {}
const FaqAnswer = ({ children }: FaqAnswerProps) => {
  return (
    <StyledAccordionDetails>
      {typeof children === 'string' ? (
        <Markdown>{children}</Markdown>
      ) : (
        children
      )}
    </StyledAccordionDetails>
  );
};

const faqData = [
  {
    question: 'What types of life insurance policies do you offer?',
    answer:
      'We offer Term Life, Whole Life, and Universal Life Insurance — each designed to meet different financial goals and needs.',
  },
  {
    question: 'How do I know how much coverage I need?',
    answer:
      'Coverage depends on your income, debts, family needs, and long-term goals. Use our calculator or talk to us for a personalized recommendation.',
  },
  {
    question: 'Can I change my beneficiaries after purchasing a policy?',
    answer:
      'Yes, you can update your beneficiaries anytime. We recommend reviewing them regularly to keep your policy current.',
  },
  {
    question: 'What happens if I miss a premium payment?',
    answer:
      'You’ll enter a 30-day grace period where coverage remains active. If unpaid after that, the policy may lapse. Contact us if you need help.',
  },
  {
    question: 'Are there any exclusions in your life insurance policies?',
    answer:
      'All policies have a standard two-year suicide exclusion. Other exclusions, if any, will be clearly explained and agreed upon before your policy starts.',
  },
];
